module.exports = __webpack_public_path__ + "9277c3d6d58f6dbc0a61974578922352.gif";